import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {

	},

	actions: {
		fetchAll ({ commit }, { versionId, employeeId, type, featureName, isArchived, fromDate, toDate, contractDate, orderByDate, Page, PerPage }) {
			const urlSearchParams = new URLSearchParams();
			const params = { versionId, type, featureName, isArchived, fromDate, toDate, contractDate, orderByDate, Page, PerPage }
			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
			employeeId.forEach(id => {
				urlSearchParams.append('employeeId', id)
			})
			return window.axios('/features', { params: urlSearchParams }).then((response) => {
				return {
					data: response.data,
					total: parseInt(response.headers['x-pagination-total-count'])
				}
			})
		},

		create ({ commit }, { title, type, notes, startDate, endDate, estimatedTime, planHours, realTime, isDone, versionId, actualDeliveryDate, contributorsIds, plannedTaskIds, taskIds }) {
			return window.axios.post('/features', { title, type, notes, startDate, endDate, estimatedTime, planHours, realTime, isDone, versionId, actualDeliveryDate, contributorsIds, plannedTaskIds, taskIds }).then(({ data }) => {
				return data
			})
		}
	}

}
